import { IVodGateway } from 'src/core/player/interfaces/VodGateway';
import VideoJsGateway from './VideoJsGateway';

class VideoJsVodGateway extends VideoJsGateway implements IVodGateway {}

export default VideoJsVodGateway;
